<!-- MODAL marcacionMasiva -->
<div mdbModal #marcacionMasiva="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Marcación Masiva
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="marcacionMasiva.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <form [formGroup]='formHeader' novalidate>
        <div class="modal-body">
          <h5>Método de Marcación Masiva</h5>
          <div class="row">


            <div class="col" style="display: flex; align-items: center;">
              <div class="switch info-switch">
                <label>
                  Desmarcar Todo
                  <input
                  hidden
                  type="checkbox"
                  id="checkBoxAllSelect"
                  (input)="setValue($event.target['checked'])"/>
                  <span class="lever"></span> Marcar Todo
                </label>
              </div>
            </div>
            <div class="col" style="display: flex; align-items: center;">
              <h6>Cliente seleccionados ({{clientesSeleccionados}})</h6>
            </div>
          </div>
          <br>

          <h5>Tipo de Marcación</h5>
          <div class="row">
            <div class="col">
              <!-- <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" id="tipoZONAS" formControlName="tipo" [value]="TIPO_ZONAS"
                  mdbInput>
                <label class="form-check-label" for="tipoZONAS">Zonas</label>
              </div> -->

              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" id="tipoRUTAS" formControlName="tipo" [value]="TIPO_RUTAS"
                  mdbInput>
                <label class="form-check-label" for="tipoRUTAS">Rutas</label>
              </div>

              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" id="tipoTERRITORIOS" formControlName="tipo"
                  [value]="TIPO_TERRITORIOS" mdbInput>
                <label class="form-check-label" for="tipoTERRITORIOS">Territorios</label>
              </div>
              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" id="tipoCLIENTE" formControlName="tipo"
                  [value]="TIPO_CLIENTE" mdbInput>
                <label class="form-check-label" for="tipoCLIENTE">Tipo Cliente</label>
              </div>
            </div>
          </div>
          <br>
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col" style="width: 1rem; min-width: 1rem; max-width: 2rem;">
                  <!-- <mdb-checkbox #checkboxAll (change)="checkAllChange($event)"></mdb-checkbox> -->
                </th>
                <th scope="col">Codigo</th>
                <th scope="col">
                  Detalle
                </th>
              </tr>
            </thead>
            <tbody *ngIf="listaMovimientos">

              <tr *ngIf="loading">
                <td colspan="100%" style="text-align: center">
                  <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </td>
              </tr>
              <tr *ngIf="!loading && listaMovimientos?.length === 0">
                <td colspan="100%" style="text-align: center">
                  No se encontró información
                </td>
              </tr>
              <tr *ngFor="let reg of listaMovimientos">
                <th scope="col">
                  <mdb-checkbox [checked]="reg.additionalInfo.checked"
                    (change)='checkDetalle(reg.additionalInfo, $event)'>
                  </mdb-checkbox>
                </th>
                <td>{{reg.codigo_marcacion}}</td>
                <td>{{reg.detalle}}</td>
              </tr>
            </tbody>
            <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
              *ngIf="listaMovimientos?.length > 0"></app-pagination>
          </table>
        </div>
      </form>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="marcacionMasiva.hide()"
          mdbWavesEffect>
          Cerrar
        </button>
        <button *ngIf="listaMovimientosAll?.length > 0" type="button" class="btn btn-secondary waves-light"
          mdbWavesEffect (click)="marcacionMasivaClientes()">
          Aceptar
        </button>
      </div>
    </div>
  </div>
</div>
